import {
  theme,
  darkTheme
} from '@contrast-security-inc/design-system-foundations'
import {
  loadingMaskCss,
  loadingMaskCssDarker,
  loadingMaskCssDarkest,
  loadingMaskCssLighter
} from './loading-text-mask'
export { LoadingTextMask, loadingAnimationCss } from './loading-text-mask'
export type { LoadingTextMaskWidthFactor } from './loading-text-mask'
export { LoadingMaskRectangle } from './loading-mask-rectangle'
export { LoadingMaskSquare } from './loading-mask-square'
export {
  LoadingMaskGradeBadgeSmall,
  LoadingMaskGradeBadgeLarge
} from './loading-mask-grade-badge'
export { LoadingMaskDonut } from './loading-mask-donut'
export { LoadingMaskSeverityBadge } from './loading-mask-severity-badge'
export { LoadingMaskThermometer } from './loading-mask-thermometer'

export type LoadingMaskColorValue = 'lighter' | 'normal' | 'darker' | 'darkest'

export function getColorValueCss(colorValue: LoadingMaskColorValue) {
  switch (colorValue) {
    case 'lighter':
      return loadingMaskCssLighter
    case 'normal':
      return loadingMaskCss
    case 'darker':
      return loadingMaskCssDarker
    case 'darkest':
      return loadingMaskCssDarkest
    default:
      throw new Error(`unexpected color value: ${colorValue}`)
  }
}

export function getLoadingMaskColors(colorValue: LoadingMaskColorValue) {
  switch (colorValue) {
    case 'lighter':
      return {
        baseColor: theme.color.neutral20,
        shimmerColor: theme.color.neutral10
      }
    case 'normal':
      return {
        baseColor: theme.color.neutral30,
        shimmerColor: theme.color.neutral20
      }
    case 'darker':
      return {
        baseColor: theme.color.neutral50,
        shimmerColor: theme.color.neutral40
      }
    case 'darkest':
      return {
        baseColor: darkTheme.color.primeBlue,
        shimmerColor: darkTheme.color.prussianBlue
      }
    default:
      throw new Error(`unexpected color value: ${colorValue}`)
  }
}
